// Config
import { defaults as Defaults } from './config';


const pureState = {
	activeLayoutType: null,
	activeMenu: null,
	activePanel: null,
	caretPosition: null,
	cleanEditorHeight: 0,
	editorContent: null,
	editorIsDirty: false,
	editorIsEditable: true,
	editorIsFocused: false,
	editorIsReady: false,
	editorTextIsSelected: false,
	errorMessage: null,
	fonts: [],
	fontsLoaded: false,
	initialSetupDone: false,
	interactionInitiated: false,
	isFocused: false,
	isLoading: true,
	layoutIsInjected: false,
	layouts: {
		desktop: {
			html: null,
			jss: null
		},
		mobile: {
			html: null,
			jss: null
		}
	},
	loadControls: false,
	loadingState: {
		productFeatures: false,
		try: false
	},

	// getDerivedStateFromProps state for checking new data against old.
	/* eslint-disable react/no-unused-state*/
	previousActiveLayoutType: null,
	previousBreakpoint: null,
	previousProductFeatures: null,
	previousProductLineID: null,
	previousCloudStyles: null,
	previousTryLayout: null,
	/* eslint-enable react/no-unused-state*/

	productFeatures: {},

	selectionIsCollapsed: true,
	selectionLength: 0,

	// Settings
	settings: {
		alignment: {
			silent: false,
			source: null,
			value: Defaults.alignment
		},
		leading: {
			silent: false,
			source: null,
			value: Defaults.leading
		},
		otFeatures: {
			silent: false,
			source: null,
			value: null
		},
		pm: {
			silent: false,
			source: null,
			value: Defaults.pm
		},
		prevSelectedFamily: null,
		prevSelectedStyle: null,
		selectedFamily: {
			id: null,
			label: null,
			silent: false,
			source: null,
			slug: null,
			styles: null,
			value: null
		},
		selectedStyle: {
			processDOM: false,
			defaultFigure: null,
			defaultStyles: {
				size: null,
				style: null,
				weight: null,
				leading: null
			},
			features: [
				{
					code: 'aalt',
					description: null
				}, {
					code: 'c2sc',
					description: null
				}, {
					code: 'case',
					description: null
				}, {
					code: 'dnom',
					description: null
				}, {
					code: 'frac',
					description: null
				}, {
					code: 'lnum',
					description: null
				}, {
					code: 'locl',
					description: null
				}, {
					code: 'numr',
					description: null
				}, {
					code: 'ornm',
					description: null
				}, {
					code: 'salt',
					description: null
				}, {
					code: 'sinf',
					description: null
				}, {
					code: 'smcp',
					description: null
				}, {
					code: 'ss05',
					description: null
				}, {
					code: 'subs',
					description: null
				}, {
					code: 'sups',
					description: null
				}, {
					code: 'tnum',
					description: null
				}, {
					code: 'onum',
					description: null
				}
			],
			id: 1103,
			label: 'Ideal Sans Book',
			source: null,
			ssm: 'IdealSansSSm-Book',
			style: 'normal',
			stylisticSets: [
				{
					code: 'ss01',
					description: 'Inscriptional G - eliminating the horizontal crossbar'
				}, {
					code: 'ss02',
					description: 'Descending J - aligned with the lowercase descenders'
				}, {
					code: 'ss03',
					description: 'Simplified Old-Style 1 - without a flag serif'
				}, {
					code: 'ss04',
					description: 'Larger ® symbol - matching the size of the copyright (©) instead of the trademark (™)'
				}
			],
			value: 'IdealSans-Book-Pro',
			weight: 400
		},
		size: {
			silent: false,
			source: null,
			value: Defaults.size
		},
		stylisticSets: {
			silent: false,
			source: null,
			value: []
		},
		tracking: {
			silent: false,
			source: null,
			value: Defaults.tracking
		}
	},

	setupStart: false,

	updateLayout: false,

	woffsLoaded: false,
	woffsLoading: false
};

export default pureState;
